class TnfInformativePage extends HTMLElement {
  connectedCallback() {
    this.sidebarLinks = Array.from(this.querySelectorAll('[data-informative-anchor-link]'));
    this.contentPanel = this.querySelector('[data-informative-content]');
    this.sidebarToggle = this.querySelector('[data-informative-sidebar-toggle]');
    this.sidebarList = this.querySelector('[data-informative-sidebar-list]');
    this.mobileQuery = window.matchMedia('(max-width: 989px)');

    this.handleClick = this.handleClick.bind(this);
    this.handleViewportChange = this.handleViewportChange.bind(this);

    this.addEventListener('click', this.handleClick);
    this.mobileQuery.addEventListener('change', this.handleViewportChange);

    this.openSidebarFromUrl();
    this.syncSidebarState();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.mobileQuery?.removeEventListener('change', this.handleViewportChange);
  }

  handleClick(event) {
    const toggle = event.target.closest('[data-informative-sidebar-toggle]');
    if (toggle instanceof HTMLButtonElement && this.contains(toggle)) {
      event.preventDefault();
      this.toggleSidebar();
      return;
    }

    const link = event.target.closest('[data-informative-anchor-link]');
    if (!(link instanceof HTMLAnchorElement) || !this.contains(link)) return;

    const targetId = link.dataset.informativeAnchorLink || '';
    if (!targetId) return;

    if (!(this.contentPanel instanceof HTMLElement)) return;

    const targetArticle = this.querySelector(`#${CSS.escape(targetId)}`);
    if (!(targetArticle instanceof HTMLElement)) return;

    const isDesktop = window.matchMedia('(min-width: 990px)').matches;
    if (!isDesktop) {
      this.sidebarToggle?.setAttribute('aria-expanded', 'false');
      this.syncSidebarState();
      return;
    }

    event.preventDefault();

    const contentPanel = this.contentPanel;
    const articleOffset = targetArticle.offsetTop - contentPanel.offsetTop;

    contentPanel.scrollTo({
      top: articleOffset,
      behavior: 'smooth',
    });

    window.history.replaceState(null, '', `#${targetId}`);
  }

  handleViewportChange() {
    this.syncSidebarState();
  }

  openSidebarFromUrl() {
    if (!(this.sidebarToggle instanceof HTMLButtonElement)) return;

    const url = new URL(window.location.href);
    const shouldOpenSidebar = this.mobileQuery.matches && url.searchParams.get('informative-menu') === 'open';
    if (!shouldOpenSidebar) return;

    this.sidebarToggle.setAttribute('aria-expanded', 'true');
    url.searchParams.delete('informative-menu');
    window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
  }

  syncSidebarState() {
    if (!(this.sidebarList instanceof HTMLElement) || !(this.sidebarToggle instanceof HTMLButtonElement)) return;

    if (this.mobileQuery.matches) {
      const isExpanded = this.sidebarToggle.getAttribute('aria-expanded') === 'true';
      this.dataset.mobileMenuOpen = String(isExpanded);
      this.sidebarList.hidden = !isExpanded;
    } else {
      delete this.dataset.mobileMenuOpen;
      this.sidebarList.hidden = false;
      this.sidebarToggle.setAttribute('aria-expanded', 'false');
    }
  }

  toggleSidebar() {
    if (!(this.sidebarToggle instanceof HTMLButtonElement) || !(this.sidebarList instanceof HTMLElement)) return;

    if (!this.mobileQuery.matches) return;

    const isExpanded = this.sidebarToggle.getAttribute('aria-expanded') === 'true';
    this.sidebarToggle.setAttribute('aria-expanded', String(!isExpanded));
    this.syncSidebarState();
  }
}

if (!customElements.get('tnf-informative-page')) {
  customElements.define('tnf-informative-page', TnfInformativePage);
}